var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c("div", { staticClass: "row mat24 flex-nowrap" }, [
      _c(
        "div",
        { staticClass: "side-bar none-mobile" },
        [
          _c(
            "base-button-group",
            [
              _c(
                "base-button",
                {
                  attrs: { btn11: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "panel-competition-mail-new",
                        params: _vm.competition,
                        alias: true,
                      })
                    },
                  },
                },
                [_vm._v(" Wyślij e-mail ")]
              ),
              _vm.canAccessSms
                ? _c(
                    "base-button",
                    {
                      attrs: { btn11: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "panel-competition-sms-new",
                            params: _vm.competition,
                            alias: true,
                          })
                        },
                      },
                    },
                    [_vm._v(" Wyślij SMS ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.competition
        ? _c(
            "div",
            { staticClass: "content-wrap" },
            [
              _c("validation-observer", {
                ref: "FormObserver",
                attrs: { tag: "div" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("panel-competition-form-box", [
                            _c("p", [_vm._v("Wiadomości e-mail")]),
                            _c("p", { staticClass: "mat16" }, [
                              _vm._v(
                                " Wiadomość wysłana zostanie wyłącznie do uczestników, którzy zapisali się na "
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.competition.name))]),
                              _vm._v(
                                ". Pamiętaj, że celem wysłania tej wiadomości jest komunikat dotyczący organizacji Twoich zawodów (np. zmiana godziny startu lub odwołanie imprezy). Wiadomość ta nie powinna być treścią marketingową a tym bardziej spamem. "
                              ),
                            ]),
                          ]),
                          _c(
                            "panel-competition-form-box",
                            { staticClass: "mat16" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-8" },
                                [
                                  _c("validation-provider", {
                                    staticClass: "scroll-margin relative",
                                    attrs: { name: "name", rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("panel-input-text", {
                                                attrs: {
                                                  label: "Temat wiadomości",
                                                  error: errors.name,
                                                },
                                                on: {
                                                  "update:error": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      errors,
                                                      "name",
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.form.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "name",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "form.name",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-error-alt",
                                                    },
                                                    [_vm._v("Pole wymagane")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "panel-competition-form-box",
                            { staticClass: "mat16" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-12 col-lg-8" },
                                [
                                  _c("validation-provider", {
                                    staticClass: "scroll-margin relative",
                                    attrs: {
                                      name: "information",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("panel-input-area", {
                                                ref: "messageArea",
                                                attrs: {
                                                  label: "Treść wiadomości",
                                                  rows: 15,
                                                  error: errors.information,
                                                },
                                                on: {
                                                  "update:error": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      errors,
                                                      "information",
                                                      $event
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.form.information,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "information",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.information",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-error-alt",
                                                    },
                                                    [_vm._v("Pole wymagane")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-12 col-lg-3" }, [
                                _c("p", { staticClass: "tags-title mat24" }, [
                                  _vm._v("Znaczniki personalizacji"),
                                ]),
                                _c("p", { staticClass: "tags-desc" }, [
                                  _vm._v(
                                    "Kliknij znacznik, aby wstawić go do treści:"
                                  ),
                                ]),
                                _c(
                                  "ul",
                                  { staticClass: "tags-list" },
                                  _vm._l(_vm.availableTags, function (tag) {
                                    return _c("li", { key: tag.key }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "tag-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.insertTag(tag.key)
                                            },
                                          },
                                        },
                                        [_vm._v(" [" + _vm._s(tag.key) + "] ")]
                                      ),
                                      _c("span", { staticClass: "tag-label" }, [
                                        _vm._v(_vm._s(tag.label)),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "panel-competition-form-box",
                            { staticClass: "mat16" },
                            [
                              _c("div", { staticClass: "w-full mab16" }, [
                                _c("p", { staticClass: "title" }, [
                                  _vm._v("Opcje wysyłki"),
                                ]),
                              ]),
                              _c("div", { staticClass: "radio-wrap" }, [
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("label", { staticClass: "mab8" }, [
                                      _vm._v("Wyślij do uczestników"),
                                    ]),
                                    _vm._l(
                                      _vm.sendPaymentOptions,
                                      function (option) {
                                        return _c("panel-input-base-radio", {
                                          key: option.value,
                                          attrs: {
                                            name: "formSendPayment",
                                            option: option,
                                          },
                                          model: {
                                            value: _vm.form.send_payment,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "send_payment",
                                                $$v
                                              )
                                            },
                                            expression: "form.send_payment",
                                          },
                                        })
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("label", { staticClass: "mab8" }, [
                                      _vm._v(
                                        "Wyślij do uczestników z wybranej kategorii"
                                      ),
                                    ]),
                                    _vm._l(
                                      _vm.classificationOptions,
                                      function (option) {
                                        return _c("panel-input-base-radio", {
                                          key: option.value,
                                          attrs: {
                                            name: "formSendClassification",
                                            option: option,
                                          },
                                          model: {
                                            value: _vm.form.send_classification,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "send_classification",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.send_classification",
                                          },
                                        })
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "div",
                                  { staticClass: "radio-wrap-column" },
                                  [
                                    _c("p", [_vm._v("Liczba odbiorców")]),
                                    !_vm.loadingCount
                                      ? _c(
                                          "b",
                                          {
                                            staticClass: "recipient-count",
                                            class: {
                                              "recipient-count--zero":
                                                _vm.recipientCount === 0,
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.recipientCount))]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "recipient-count recipient-count--loading",
                                          },
                                          [_vm._v("Ładowanie...")]
                                        ),
                                    !_vm.loadingCount &&
                                    _vm.recipientCount === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "no-recipients-warning",
                                          },
                                          [
                                            _vm._v(
                                              " Brak odbiorców spełniających wybrane kryteria. Zmień opcje wysyłki, aby wysłać wiadomość. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "actions-wrap" },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    btn2: "",
                                    short: "",
                                    disabled: _vm.loadingCsv,
                                  },
                                  on: { click: _vm.downloadEmailsCsv },
                                },
                                [
                                  !_vm.loadingCsv
                                    ? _c("span", [
                                        _vm._v("Pobierz listę e-maili"),
                                      ])
                                    : _c("span", [_vm._v("Pobieranie...")]),
                                ]
                              ),
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    btn1: "",
                                    short: "",
                                    disabled:
                                      _vm.isWaiting ||
                                      _vm.recipientCount === 0 ||
                                      _vm.loadingCount,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return handleSubmit(_vm.submit)
                                    },
                                  },
                                },
                                [
                                  !_vm.isWaiting
                                    ? _c("span", [_vm._v("Wyślij wiadomość")])
                                    : _c("span", [_vm._v("Wysyłanie...")]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3682926925
                ),
              }),
              _c("div", { staticClass: "mailings-section mat32" }, [
                _c("p", { staticClass: "mailings-section__title" }, [
                  _vm._v("Wysłane wiadomości e-mail"),
                ]),
                _vm.loadingMailings
                  ? _c("div", { staticClass: "mailings-loading" }, [
                      _vm._v("Ładowanie listy mailingów..."),
                    ])
                  : _vm.mailingError
                  ? _c("div", { staticClass: "mailings-error" }, [
                      _vm._v(_vm._s(_vm.mailingError)),
                    ])
                  : _c("table", { staticClass: "mailings-table" }, [
                      _vm._m(1),
                      _c(
                        "tbody",
                        [
                          _vm.mailings.length === 0
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "mailings-table__empty",
                                    attrs: { colspan: "8" },
                                  },
                                  [_vm._v("Brak wysłanych wiadomości")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.mailings, function (mailing) {
                            return _c(
                              "tr",
                              {
                                key: mailing.id,
                                staticClass: "mailings-table__row",
                                on: {
                                  click: function ($event) {
                                    return _vm.openMailingDetail(mailing.id)
                                  },
                                },
                              },
                              [
                                _c("td", [_vm._v(_vm._s(mailing.name))]),
                                _c("td", [_vm._v(_vm._s(mailing.type))]),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status-badge",
                                      class: `status-badge--${mailing.status}`,
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.statusLabel(mailing.status)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(mailing.emails_send) +
                                      " / " +
                                      _vm._s(mailing.emails_count)
                                  ),
                                ]),
                                _c("td", [
                                  _c("div", { staticClass: "progress-wrap" }, [
                                    _c("div", { staticClass: "progress-bar" }, [
                                      _c("div", {
                                        staticClass: "progress-bar__fill",
                                        style: {
                                          width: mailing.progress + "%",
                                        },
                                      }),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "progress-pct" },
                                      [_vm._v(_vm._s(mailing.progress) + "%")]
                                    ),
                                  ]),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(mailing.sended))
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(mailing.started_at))
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.formatDate(mailing.completed_at))
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
              ]),
              _c("modal", {
                ref: "mailingModal",
                attrs: { size: "xl" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedMailing
                                  ? _vm.selectedMailing.name
                                  : "Szczegóły mailingu"
                              )
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _vm.loadingDetail
                            ? _c("div", { staticClass: "modal-loading" }, [
                                _vm._v("Ładowanie szczegółów..."),
                              ])
                            : _vm.selectedMailing
                            ? _c("div", { staticClass: "mailing-detail" }, [
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Status:")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "status-badge",
                                        class: `status-badge--${_vm.selectedMailing.status}`,
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.statusLabel(
                                                _vm.selectedMailing.status
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Typ:")]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.selectedMailing.type)),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Postęp:")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "progress-wrap" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "progress-bar" },
                                          [
                                            _c("div", {
                                              staticClass: "progress-bar__fill",
                                              style: {
                                                width:
                                                  _vm.selectedMailing.progress +
                                                  "%",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "progress-pct" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedMailing.progress
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Wysłano / Całość / Niewysłane:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedMailing.emails_send
                                        ) +
                                          " / " +
                                          _vm._s(
                                            _vm.selectedMailing.emails_count
                                          ) +
                                          " / " +
                                          _vm._s(
                                            _vm.selectedMailing.emails_nosend
                                          )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Data wysłania:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTimestamp(
                                            _vm.selectedMailing.sended
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Data startu:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.selectedMailing.started_at
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mailing-detail__row" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mailing-detail__label" },
                                      [_vm._v("Data zakończenia:")]
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.selectedMailing.completed_at
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm.selectedMailing.information
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mailing-detail__row mailing-detail__row--col",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mailing-detail__label",
                                          },
                                          [_vm._v("Treść:")]
                                        ),
                                        _c(
                                          "pre",
                                          {
                                            staticClass:
                                              "mailing-detail__content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedMailing.information
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.selectedMailing.emails_list
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mailing-detail__row mailing-detail__row--col",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mailing-detail__label",
                                          },
                                          [_vm._v("Lista e-maili:")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "mailing-detail__emails",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedMailing.emails_list
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.selectedMailing.emails_error
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mailing-detail__row mailing-detail__row--col",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mailing-detail__label",
                                          },
                                          [_vm._v("Błędy:")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "mailing-detail__error-list",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedMailing.emails_error
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("div"),
                          _c(
                            "base-button",
                            {
                              attrs: { btn2: "", short: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.mailingModal.closeModal()
                                },
                              },
                            },
                            [_vm._v("Zamknij")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2932772239
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mat32" }, [
      _c("div", { staticClass: "col-12 title" }, [_vm._v("Wiadmości")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nazwa")]),
        _c("th", [_vm._v("Typ")]),
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Wysłano / Całość")]),
        _c("th", [_vm._v("Postęp")]),
        _c("th", [_vm._v("Data wysłania")]),
        _c("th", [_vm._v("Data startu")]),
        _c("th", [_vm._v("Data zakończenia")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }